import React from 'react';
import { withRouter } from 'react-router-dom';

import { VpTablePagination } from '@vp-ui';
import { useFetchVideoCompilations } from '@src/hooks';

export const VpVideoCompilationsTablePagination = withRouter(() => {
  const { data } = useFetchVideoCompilations();
  const meta = data?.recordMetadata;

  return <VpTablePagination data={{ meta }} />;
});

export default VpVideoCompilationsTablePagination;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpVideoCompilationTable/VpVideoCompilationsTablePagination.jsx